// extracted by mini-css-extract-plugin
export default {"logo":"NavTabs_logo__X3IjZ","navItem":"NavTabs_navItem__NJCki"};